module.exports = "/_next/static/images/networkAudit-fcac2875c55728e0deef1aebc9616495.webp";